<template>
    <chart :options="option" :loading="loading" class="echarts" ref="echartsize" :auto-resize="true" theme="walden"></chart>
</template>

<script>
import chart from "vue-echarts";
require('echarts');//引入所有表
import '@/assets/js/walden'
export default {
  name: 'OrderEchart',
    components: {
        chart
    },
    props : {
      search : Object
    },
  data () {
    return {
        loading : false,
        option : {
            backgroundColor: '#FFFFFF',
            tooltip: {
                trigger: 'axis'
            },
            legend: {
                padding : [40 , 0 , 0 , 0],
                data : [
                    {
                    name: '订单总额',
                    // 强制设置图形为圆。
                    icon: 'circle',
                },{
                    name: '应收金额',
                    // 强制设置图形为圆。
                    icon: 'circle',
                },{
                    name: '应付金额',
                    // 强制设置图形为圆。
                    icon: 'circle',
                },{
                    name: '实收金额',
                    // 强制设置图形为圆。
                    icon: 'circle',
                },{
                        name: '实付金额',
                        // 强制设置图形为圆。
                        icon: 'circle',
                    }],
            },
            grid : {
                left : '60px',
                top : '80px',
                right : '20px',
            },
            toolbox: {
                show: false,
                feature: {
                    magicType: {type: ['line', 'bar']},
                    saveAsImage: {}
                }
            },
            xAxis: {
                type: 'category',
                boundaryGap: false,
                data: [],
                axisLabel: {    // 坐标轴标签
                    rotate: 30, // 旋转角度
                },
            },
            yAxis: {
                type: 'value',
                axisLabel: {
                    formatter: '{value}'
                },
            },
            series: [
                {
                    name: '订单总额',
                    type: 'line',
                    barWidth: 12,
                    smooth : true,
                    data: [],
                    itemStyle: {
                        normal: {
                            barBorderRadius:[3, 3, 0, 0], // 设置柱状图圆角
                        }
                    }
                },
                {
                    name: '应收金额',
                    type: 'line',
                    barWidth: 12,
                    smooth : true,
                    data: [],
                    itemStyle: {
                        normal: {
                            barBorderRadius:[3, 3, 0, 0], // 设置柱状图圆角
                        }
                    }
                },
                {
                    name: '应付金额',
                    type: 'line',
                    barWidth: 12,
                    smooth : true,
                    data: [],
                    itemStyle: {
                        normal: {
                            barBorderRadius:[3, 3, 0, 0], // 设置柱状图圆角
                        }
                    }
                },
                {
                    name: '实收金额',
                    type: 'line',
                    barWidth: 12,
                    smooth : true,
                    data: [],
                    itemStyle: {
                        normal: {
                            barBorderRadius:[3, 3, 0, 0], // 设置柱状图圆角
                        }
                    }
                },
                {
                    name: '实付金额',
                    type: 'line',
                    barWidth: 12,
                    smooth : true,
                    data: [],
                    itemStyle: {
                        normal: {
                            barBorderRadius:[3, 3, 0, 0], // 设置柱状图圆角
                        }
                    }
                }
            ]
        },
    }
  },
    created(){
        // this.GetStaticEchart(e);
    },
    mounted(){
        let that = this;
        this.$nextTick(() => {
            this.$refs.echartsize.resize();
        })
    },
    methods: {
        GetOrderEchart(){
            let that = this;
            that.loading = true;
            that.$axios.get('/admin/index/getOrderStatic')
                .then(function (e) {
                    if(e.code == 0) {
                        let data = e.data;
                        that.option.xAxis.data = data.date;
                        that.option.series[0].data = data.total_money;
                        that.option.series[1].data = data.customer_money;
                        that.option.series[2].data = data.pay_money;
                        that.option.series[3].data = data.use_customer_money;
                        that.option.series[4].data = data.use_pay_money;
                    }else{
                        that.$Message.error({ background: true,duration:3, content:e.msg});
                    }
                })
                .catch(function (e) {
                    that.$Message.error({ background: true,duration:3, content:'请求发送失败'});
                });
        }

    },
    watch: {
        // search: {
        //     deep: true,
        //     handler (val) {
        //         this.GetStaticEchart(val);
        //     }
        // }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">

</style>



// WEBPACK FOOTER //
// src/components/echart/OrderEchart.vue